import React, { useMemo } from 'react';
import { create } from 'jsondiffpatch';
import { format, showUnchanged, hideUnchanged } from 'jsondiffpatch/formatters/html';
import 'jsondiffpatch/formatters/styles/html.css';

import { Swatches } from '../base/variables/variables';

interface JsonDiffReactProps {
    right: any;
    left: any;
    show?: boolean;
    tips?: React.ReactNode;
    objectHash?: (obj: any) => any;
}

export const JsonDiffReact: React.FC<JsonDiffReactProps> = ({
    right,
    left,
    show = true,
    tips = 'Both objects are identical.',
    objectHash,
}) => {
    const html = useMemo(() => {
        if (left === undefined && right === undefined) return null;
        const instance = create({ objectHash });
        const delta = instance.diff(left, right);
        if (!delta) return null;

        if (!show) {
            hideUnchanged();
        } else {
            showUnchanged();
        }

        return format(delta, left) as string;
    }, [left, right, objectHash, show]);

    if (!html) {
        if (typeof tips === 'string') {
            return React.createElement('p', { style: { fontSize: 12, color: Swatches.Gray5 } }, tips);
        }
        return React.createElement(React.Fragment, null, tips);
    }

    return React.createElement('div', { dangerouslySetInnerHTML: { __html: html } });
};
